import Switch from "react-switch";

export default Switch;
